
import { create } from "zustand";

const useMusicTitleUpdateStore = create((set) => ({
    data:{},
    setData: (data) => set(() => ({data : data })),
}));

export default useMusicTitleUpdateStore;
